import { render } from "./buttons.vue?vue&type=template&id=6dac4881&scoped=true"
import script from "./buttons.vue?vue&type=script&lang=js"
export * from "./buttons.vue?vue&type=script&lang=js"

import "./buttons.vue?vue&type=style&index=0&id=6dac4881&scoped=true&lang=css"

import exportComponent from "D:\\Program Files\\vueProject\\sys-bg-sjyy\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dac4881"]])

export default __exports__